import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useSelector } from "react-redux";
import AdminService from "../../../../../services/AdminManagment/AdminService";
import { Translate } from "../../../../Enums/Tranlate";
import RolesService from "../../../../../services/AdminManagment/RolesService";

const AddAdmin = () => {
	const location = useLocation();
	const [formData, setFormData] = useState({
		first_name: "",
		last_name: "",
		email: "",
		phone: "",
		password: "",
		roleId: [],
	});
	const [loading, setLoading] = useState(false);
	const [showPassword, setShowPassword] = useState(false);
	const [rolesOptions, setRolesOptions] = useState([]);
	const navigate = useNavigate();
	const adminService = new AdminService();
	const lang = useSelector((state) => state.auth?.lang);

	useEffect(() => {
		if (location?.state?.edit) {
			let item = location.state?.item;

			setFormData({
				first_name: item?.firstName,
				last_name: item?.lastName,
				email: item?.email,
				phone: item?.phoneNumber,
				password: "",
				roleId: {
					label: item?.role?.name,
					value: item?.role?.id,
				},
			});
		}
		new RolesService().getList({ page: 1, limit: 100 }).then((res) => {
			if (res?.status) {
				setRolesOptions(
					res?.data?.data?.data?.map((info) => ({
						label: info?.name,
						value: info?.id,
					}))
				);
			}
		});
	}, []);

	const inputHandler = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	const onSubmit = (e) => {
		e.preventDefault();
		if (!formData.roleId) {
			toast.error("Select Role");
			return;
		}
		let data = {
			firstName: formData?.first_name,
			lastName: formData?.last_name,
			phoneNumber: formData?.phone,
			email: formData?.email,
			roleId: formData.roleId?.value,
		};

		if (location?.state?.edit) {
			setLoading(true);
			adminService.update(location.state?.id, data).then((response) => {
				if (response?.status === 200) {
					toast.success(Translate[lang].admin_updated_successfully);
					navigate("/");
				}
				setLoading(false);
			});
		} else {
			data["password"] = formData?.password;

			setLoading(true);
			adminService.create(data).then((response) => {
				if (response?.status === 201) {
					toast.success(
						`${Translate[lang].added} ${Translate[lang].admin} ${Translate[lang].successfully}`
					);
					navigate("/admins");
				}
				setLoading(false);
			});
		}
	};

	return (
		<Card className="p-4">
			<AvForm onValidSubmit={onSubmit}>
				<div className="row">
					<div className="col-md-3">
						<AvField
							label={`${Translate[lang]?.first_name}`}
							name="first_name"
							type="text"
							value={formData?.first_name}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							placeholder={`${Translate[lang]?.first_name}`}
							onChange={(e) => inputHandler(e)}
						/>
					</div>
					<div className="col-md-3">
						<AvField
							label={`${Translate[lang]?.last_name}`}
							name="last_name"
							type="text"
							value={formData?.last_name}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							placeholder={`${Translate[lang]?.last_name}`}
							onChange={(e) => inputHandler(e)}
						/>
					</div>
					<div className="col-md-6">
						<AvField
							label={`${Translate[lang]?.email}`}
							name="email"
							type="email"
							value={formData?.email}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							placeholder="example@example.com"
							onChange={(e) => inputHandler(e)}
						/>
					</div>
					<div className="col-md-6">
						<AvField
							label={`${Translate[lang]?.password}`}
							name="password"
							type={`${showPassword ? "password" : "text"}`}
							value={formData?.password}
							validate={{
								required: {
									value: !location?.state?.edit,
									errorMessage: Translate[lang].field_required,
								},
							}}
							onFocus={(e) => setShowPassword(false)}
							onBlur={(e) => setShowPassword(true)}
							placeholder={`${Translate[lang]?.password}`}
							onChange={(e) => inputHandler(e)}
						/>
					</div>
					<div className="col-md-6">
						<AvField
							label={`${Translate[lang]?.phone}`}
							name="phone"
							type="number"
							value={formData?.phone}
							validate={{
								required: {
									value: true,
									errorMessage: Translate[lang].field_required,
								},
							}}
							placeholder={`${Translate[lang]?.phone}`}
							onChange={(e) => inputHandler(e)}
						/>
					</div>
					<div className="col-md-6 col-sm-6 mb-3">
						<label className="text-label">{Translate[lang]?.role}</label>
						<Select
							value={formData?.roleId}
							name="roleId"
							placeholder={Translate[lang]?.select}
							options={rolesOptions}
							onChange={(e) => setFormData({ ...formData, roleId: e })}
						/>
					</div>
				</div>
				<div className="d-flex justify-content-between mt-5">
					<Button
						variant="secondary"
						type="button"
						onClick={() => navigate("/admins")}>
						{Translate[lang]?.cancel}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{Translate[lang]?.submit}
					</Button>
				</div>
			</AvForm>
		</Card>
	);
};

export default AddAdmin;
